exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".news-item[data-v-7bacbc7f]{display:block;margin-bottom:2rem}.news-item[data-v-7bacbc7f]:last-child{margin-bottom:0}.post-title[data-v-7bacbc7f]{color:#003f87;margin-bottom:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bacbc7f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/home/news-feed/NewsItem.vue
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-7bacbc7f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/home/news-feed/NewsItem.vue
// module chunks = 0